import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { Tabs, TabItem } from '../common/Tabs';
import { ScopeRangePicker } from './ScopeRangePicker';

const TABS: TabItem[] = [
  { key: '', label: 'Fleet' },
  { key: 'availability', label: 'Availability' },
  { key: 'incidents', label: 'Incident rate' },
  { key: 'response', label: 'Response time' },
];

export function ReportsShell() {
  useDocumentTitle('Reports');
  const navigate = useNavigate();
  const location = useLocation();

  // '/reports' -> '', '/reports/availability' -> 'availability'
  const active = location.pathname.replace(/^\/reports\/?/, '').split('/')[0];

  function go(key: string) {
    // location.search is carried across tabs so scope, range and compare
    // survive a switch -- one question, four views.
    navigate({ pathname: key ? `/reports/${key}` : '/reports', search: location.search });
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Reports</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Uptime, incidents and response time across any set of services and any period.
        </p>
      </div>
      <ScopeRangePicker />
      <Tabs tabs={TABS} value={active} onChange={go} idBase="reports" />
      <Outlet />
    </div>
  );
}
